import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, renderComponent, withProps } from 'recompose';
import { routes } from '../../../../constants';
import { Icon, SortableTable } from '../../../components';
import Loading from '../../loading';

const columns = [
  {
    name: 'name',
    display: () => 'Title',
    className: () => "name wide",
  },
  {
    name: 'defaultCpdPoints',
    display: () => 'Default Cpd Points',
    className: () => "defaultCpdPoints narrow",
  },
  {
    name: 'defaultCpdDay',
    display: () => 'Default Cpd Day',
    className: () => "defaultCpdDay narrow",
  },
  {
    name: 'defaultCpdMonth',
    display: () => 'Default Cpd Month',
    className: () => "defaultCpdMonth narrow",
  },
  {
    name: 'identifier',
    display: () => 'Identifier',
    className: () => "identifier wide",
  },
  {
    name: 'industryType',
    display: () => 'Industry Type',
    className: () => "industryType wide",
  },
  {
    name: 'maxMicroCpdPortion',
    display: () => 'Max Micro Cpd Portion',
    className: () => "maxMicroCpdPortion narrow",
  },
  {
    name: 'capCpdActivity',
    display: () => 'Formal Education Capping',
    className: () => "capCpdActivity narrow",
  },
  {
    name: 'includeTasa',
    display: () => 'Include TPB',
    className: () => "includeTasa narrow",
  },
  {
    name: 'signUpLink',
    display: () => 'Sign Up Link',
    className: () => "signUpLink wide",
  },
  {
    name: 'edit',
    display: () => 'Edit',
    className: () => "edit",
  }
];

const AdminIndustry = ({
  rows
}) => (
    <div className='base-layout'>
      <section className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12}>
              <h1>Industry admin</h1>
            </Col>
          </Row>
        </Grid>
      </section>
      <section id='section--admin-industry' className='layout--section'>
        <Grid>
          <Row className='xs-gutter'>
            <Col xs={12} md={9}>
              <h2><Icon icon='caddie-links-large-alt' /> Industries</h2>
              <p>Add or manage Industries.</p>
            </Col>
            <Col xs={12} md={3}>
              <p>
                <LinkContainer to={routes.adminPortal.industryAdd}>
                  <Button className='large full'>
                    <Icon icon='add-large' /> Add Industry
                  </Button>
                </LinkContainer>
              </p>
            </Col>
          </Row>
          <SortableTable rows={rows} columns={columns} className='table--admin-industry' />
        </Grid>
      </section>
    </div >
  );

const mapStateToProps = (state) => ({
  industries: state.industry.industries
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ industries }) => industries.length === 0,
    renderComponent(Loading)
  ),
  withProps(
    ({ industries }) => ({
      rows: fp.flow(
        fp.map(
          (industry) => ({
            ...industry,
            includeTasa: industry.includeTasa ? 'Yes' : 'No',
            capCpdActivity: industry.capCpdActivity ? industry.capCpdActivity : '-',
            signUpLink: industry.identifier === industries.financialAdviser ? `/onboarding/choose-plan` : `/onboarding/choose-plan/${industry.identifier}`,
            edit: <LinkContainer to={routes.adminPortal.industryEdit(industry.id)}>
              <Button bsStyle='plain'><Icon icon='edit-medium' />Edit</Button>
            </LinkContainer>
          })
        ),
        fp.sortBy(
          row => row.name
        )
      )(industries)
    })
  )
)(AdminIndustry);


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/industry-portal/industry.js